module.exports = __webpack_public_path__ + "static/media/jm.a7ca963e.svg";